import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { PageHeader, Loading, Empty, Plate, VehicleStatus, DemoTag, ExportBtn, useFetch } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { fNum, fDate } from "@/lib/api";

export default function LivVehicles() {
  const { user } = useAuth();
  const { data, loading } = useFetch("/vehicles", { type: "livraison" });
  return (
    <div data-testid="liv-vehicles-page">
      <PageHeader overline="Véhicules de livraison" title="Véhicules">
        {user.role === "admin" && <ExportBtn path="/export/vehicles" params={{ type: "livraison" }} filename="vehicules-livraison.xlsx" testid="export-liv-vehicles" />}
      </PageHeader>
      {loading ? <Loading /> : !data?.length ? <Empty /> : (
        <div className="grid sm:grid-cols-2 xl:grid-cols-3 gap-4">
          {data.map((v, i) => (
            <Link key={v.id} to={`/livraison/vehicules/${v.id}`} data-testid={`vehicle-card-${v.plate}`}
              className="group rise bg-white border border-slate-200 rounded-xl p-5 hover:border-[#0E2D43] hover:shadow-md transition-[border-color,box-shadow]"
              style={{ animationDelay: `${i * 40}ms` }}>
              <div className="flex items-center justify-between">
                <Plate>{v.plate}</Plate>
                <div className="flex gap-1.5"><DemoTag show={v.is_demo} /><VehicleStatus v={v.status} /></div>
              </div>
              <div className="font-display text-xl font-bold text-[#0E2D43] mt-4">{v.brand} {v.model}</div>
              <div className="text-sm text-slate-500">{v.engine} · mise en circulation {fDate(v.first_registration)}</div>
              <div className="mt-4 flex items-end justify-between">
                <div>
                  <div className="text-[11px] uppercase font-bold tracking-wider text-slate-400">Kilométrage</div>
                  <div className="font-mono font-bold text-lg text-[#0E2D43]">{fNum(v.mileage)} km</div>
                  <div className="text-xs text-slate-500 mt-1">Dernier chauffeur attribué : {v.last_driver_name || "—"}</div>
                </div>
                <ChevronRight className="w-5 h-5 text-slate-300 group-hover:text-[#F49619] group-hover:translate-x-1 transition-[color,transform]" />
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
